module.exports = __webpack_public_path__ + "static/img/d_map.1d067ad6.gif";